import React, { useEffect, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { Box, Button, Flex, Header, styled } from '@driftt/dds'
import {
  JobDesignation,
  useJobDesignation,
} from '@driftt/onboarding-components'

import * as UserSelectors from 'modules/user/selectors'
import { resolveCompletionUrl } from 'utils/routing'
import { page, track } from 'utils/trackingUtils'

import useFeatureCheck from './useFeatureCheck.hook'

const GlobalStylesOverrides = styled(Box, {
  '& label': {
    margin: '0px!important',
  },
  '& p': {
    margin: '0px!important',
  },
})

const JobDesignationStepContainer = styled(Flex, {
  paddingBottom: '$2',
})

const CompleteButton = styled(Button, {
  alignSelf: 'center',
})

const JOB_DESIGNATION_STEP_DESCRIPTION =
  'Help us understand your current role and responsibilities so we can give you the best experience in Drift. This information can be updated in Settings at any time.'

export const JobDesignationStep = () => {
  const userId = useSelector((state) => UserSelectors.getUserId(state))
  const flow = useSelector((state) => UserSelectors.getFlow(state))

  const { hasFeature } = useFeatureCheck()

  const hasProfile = useMemo(
    () => hasFeature({ featureName: 'profile', accessLevel: 'WRITE' }),
    [hasFeature]
  )

  const redirect = () => (window.location.href = resolveCompletionUrl(flow))

  const handleComplete = () => redirect()
  const handleTrack = ({ tasks, title, area }) =>
    track('Responsibilities Designation Step', {
      tasks,
      title,
      area,
    })

  const { onUpdate, isUpdating, ...rest } = useJobDesignation({
    userId,
    hasProfile,
    onComplete: handleComplete,
    onTrack: handleTrack,
  })

  useEffect(() => {
    page('Responsibilities Designation Step')
  }, [])

  return (
    <GlobalStylesOverrides>
      <JobDesignationStepContainer
        direction="column"
        className="onboarding-job-tasks-step"
        alignItems="center"
      >
        <Header variant="h1">What best describes your role?</Header>
        <JobDesignation
          {...rest}
          description={JOB_DESIGNATION_STEP_DESCRIPTION}
        />
        <CompleteButton onClick={onUpdate} loading={isUpdating}>
          Complete set up
        </CompleteButton>
      </JobDesignationStepContainer>
    </GlobalStylesOverrides>
  )
}
